export const STEP_AUTH = "STEP_AUTH"
// export const STEP_SUBSCRIBE = "STEP_SUBSCRIBE"
export const STEP_SCHOOL = "STEP_SCHOOL"
export const STEP_LICENSE = "STEP_LICENSE"
export const STEP_CREATED = "STEP_CREATED"
export const STEP_ORDER_CONFIRMATION = "STEP_ORDER_CONFIRMATION"
